
import CryptoJS from "crypto-js";
function getTokenEncript(objectArray: Array<{ key: string; value: string }>) {
    const secretKey = process.env.REACT_APP_SECRET || "sfdsfasdfsdf3434$$$";
    
    objectArray?.forEach(({ key, value }) => {
      try {
        // Check if the value is valid and a non-empty string
        if (typeof value === "string" && value.trim().length > 0) {
          const encryptedValue = CryptoJS.AES.encrypt(value, secretKey).toString();
          localStorage.setItem(key, encryptedValue);
        } else {
          console.error(`Invalid value for key: ${key}`);
        }
      } catch (error) {
        console.error(`Error encrypting value for key: ${key}`, error);
      }
    });
  }
  



export default  getTokenEncript;
